import React, { useState } from 'react';
import styled from 'styled-components';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Tickets from '../components/Tickets';
import { useNavigate, useParams } from 'react-router-dom';
import { Helmet } from "react-helmet-async";
import { HiOutlineBuildingLibrary } from "react-icons/hi2";
import { FaSearch, FaTheaterMasks } from 'react-icons/fa';
import { MdOutlineLunchDining } from "react-icons/md";
import { TbRollercoaster } from "react-icons/tb";
import { GiKidSlide } from "react-icons/gi";
import { BiSpa } from "react-icons/bi";

const LocationWrapper = styled.div`
  width: 100%;
`;

const LocationHeader = styled.div`
  width: 100%;
  padding-top: 50%;
  position: relative;
  overflow: hidden;
`;

const LocationHeaderImg = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  position: absolute;
  top: 0;
  left: 0;
  filter: brightness(90%);
`;

const GradientOverlay = styled.div`
  position: absolute;
  bottom: 0;
  width: 100%;
  height: 10%;
  background: linear-gradient(to bottom, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 1) 100%);
`;

const LocationOverlay = styled.div`
  position: absolute;
  bottom: 20px;
  left: 20px;
  color: white;
  padding: 10px;
  z-index: 1;
  max-width: 80%;
  border-radius: 8px;
`;

const LocationMiddle = styled.div`
  padding: 10px 20px;
`;

const PageDesc = styled.div`
  color: #5B5B5B;
  font-size: 10px;
  font-weight: 400;
`;

const SearchPart = styled.div`
  width: 100%;
  position: relative;
  margin: 18px auto;
`;

const SearchIcon = styled(FaSearch)`
  position: absolute;
  left: 12px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 18px;
  color: #bbb;
`;

const SearchInput = styled.input`
  width: -webkit-fill-available;
  padding: 10px 40px;
  font-size: 13px;
  border: 1px solid #C4C4C4;
  border-radius: 36px;
  outline: none;

  &::placeholder {
    color: #818181;
  }
`;

const CategoryWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  justify-content: center;
  gap: 8px;
  margin-top: 25px;
`;

const CategoryContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
`;

const Category = styled.div`
  width: 46px;
  height: 46px;
  border-radius: 18px;
  background-color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: 0px 0px 3px 0px rgba(0, 0, 0, 0.25);
  cursor: pointer;
`;

const CategoryText = styled.div`
  margin: 2px 0;
  color: black;
  font-size: 12px;
  font-weight: 500;
`;

const ShowMoreButton = styled.button`
  width: 100%;
  margin: 10px auto;
  padding: 8px;
  border: none;
  background-color: white;
  box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.25);
  border-radius: 18px;
  color: black;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
`;

const Ads = styled.div`
  margin: 30px auto;
`;

const TempAds = styled.div`
  width: 100%;
  padding-top: 50%;
  background-color: #c8c8c8;
  border-radius: 15px;
  box-shadow: 0px 0px 6px rgba(0, 0, 0, 0.2);
  position: relative;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  
  h1 {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    color: #333;
  }
`;

// const AdImage = styled.div`
//   width: 100%;
//   padding-top: 50%;
//   background-size: cover;
//   background-position: center;
//   border-radius: 15px;
//   box-shadow: 0px 0px 6px rgba(0, 0, 0, 0.2);
//   position: relative;
//   overflow: hidden;

//   img {
//     position: absolute;
//     top: 0;
//     left: 0;
//     width: 100%;
//     height: 100%;
//     object-fit: cover;
//   }
// `;


const LocationTickets = styled.div`
  width: 100%;
`;

const Title = styled.h3`
  margin-left: 20px;
  color: #3E3E3E;
  font-size: 20px;
  font-weight: bold;
  position: relative;
  display: inline-block;

  &::after {
    content: "";
    display: block;
    width: 100%;
    height: 10px;
    background-color: #d3d3d3;
    position: absolute;
    bottom: 0;
    left: 0;
    z-index: -1;
  }
`;

function Location() {

  // 임시 데이터-----------------------------------------------------------
  const categories = [
    { icon: <HiOutlineBuildingLibrary size={30} />, text: "Museums & Galleries" },
    { icon: <TbRollercoaster size={30} />, text: "Amusement Parks" },
    { icon: <GiKidSlide size={30} />, text: "Kids Activities" },
    { icon: <FaTheaterMasks size={30} />, text: "Art & Theater" },
    { icon: <BiSpa size={30} />, text: "Beauty & Spas" },
    { icon: <MdOutlineLunchDining size={30} />, text: "Tour" },
    { icon: <HiOutlineBuildingLibrary size={30} />, text: "More Activities" },
  ];

  const getLocationImage = (cityName) => {
    const cityImages = {
      "New York": "/assets/country/america/NewYork.jpg",
      "Miami": "/assets/country/america/Miami.jpg",
      "Orlando": "/assets/country/america/Orlando.jpg",
      "San Francisco": "/assets/country/america/SanFrancisco.jpg",
      "Los Angeles": "/assets/country/america/LosAngeles.jpg",
      "Chicago": "/assets/country/america/Chicago.jpg"
    };
  
    return cityImages[cityName] || "/assets/country/tempBackground.jpg";
  };
  
  const tempAd = [
    "ads part1",
    "ads part2",
    "ads part3"
  ];

  const { location } = useParams();
  const navigate = useNavigate();
  const [searchText, setSearchText] = useState('');
  const [showAll, setShowAll] = useState(false);

  const handleSearchChange = (e) => {
    setSearchText(e.target.value);
  };

  const handleSearchKeyDown = (e) => {
    if (e.key === "Enter" && searchText.trim() !== "") {
      navigate(`/location/${location}/search?keyword=${encodeURIComponent(searchText.trim())}`);
    }
  };

  const visibleCategories = showAll ? categories : categories.slice(0, 5);

  const handleShowMore = () => {
    setShowAll((prev) => !prev);
  };

  const handleCategoryClick = (category) => {
    const encodedCategory = encodeURIComponent(category);
    navigate(`/location/${location}/${encodedCategory}`);
  };

  const sliderSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 10000,
    arrows: false,
  };

  return (
    <>
      <Helmet>
        <title>{location} - MusePicker</title>
        <meta name="description" content={`Explore events in ${location}`} />
        <meta name="keywords" content={`${location}, events`} />
        <meta name="author" content="MusePicker" />
      </Helmet>

      <LocationWrapper>
        <LocationHeader>
          <LocationHeaderImg src={getLocationImage(location)} alt={`${location} Image`} />
          <GradientOverlay />
          <LocationOverlay>
            <h1>{location}</h1>
          </LocationOverlay>
        </LocationHeader>

        <LocationMiddle>
          <PageDesc>Home &gt; {location}</PageDesc>          
          <SearchPart>
            <SearchIcon />
            <SearchInput
              type="text"
              placeholder={`Search for things to do in ${location}`}
              value={searchText}
              onChange={handleSearchChange}
              onKeyDown={handleSearchKeyDown}
            />
          </SearchPart>

          <CategoryWrapper>
            {visibleCategories.map((category, index) => (
              <CategoryContent key={index}
                onClick={() => handleCategoryClick(category.text)}
              >
                <Category>{category.icon}</Category>
                <CategoryText>{category.text}</CategoryText>
              </CategoryContent>
            ))}
          </CategoryWrapper>
          {categories.length > 5 && (
            <ShowMoreButton onClick={handleShowMore}>
              {showAll ? "- Less Categories" : "+ All Categories"}
            </ShowMoreButton>
          )}

          <Ads>
            <Slider {...sliderSettings}>
              {/* {adImages.map((src, index) => (
                <AdImage key={index}><img src={src} alt="ads"/></AdImage>
              ))} */}
              {tempAd.map((adstr, index) => (
                <TempAds><h1>{adstr}</h1></TempAds>
              ))}
            </Slider>
          </Ads>
        </LocationMiddle>

        <LocationTickets>
          <Title>Popular Tickets in {location}</Title>
          <Tickets location={location} />
        </LocationTickets>
      </LocationWrapper>
    </>
  );
}

export default Location;